/* template */
<template><div><div :style="[(warpStyle2)] | transRpxStyle" class="warp"><template v-if="(!error)"><mpx-text :style="[(ruleStyle)] | transRpxStyle" @tap="gotoLink(pageConfig.rule.link)" class="rule">规则</mpx-text><red-packet-close :config="(redPacketConfig)" :couponInfo="(activityCouponInfo)" :btnText="(btnText)" packetType="launch-app" @click="toApp" @launchApp="toApp" v-if="(activityCouponInfo)"/><res-banner :template="(info.template)" v-if="(activityCouponInfo)"/></template><error-view :error="(error)" :message="(errmsg)" v-else/></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m35525490"}'>
  .warp
    min-height 100vh
    width 100vw
    padding-bottom 72rpx
    overflow hidden
    box-sizing: border-box;
    background-size 100vw auto
    background-repeat no-repeat
    line-height: normal;
    position relative
    .rule
      position absolute
      right 0
      border-radius: 100rpx 0 0 100rpx;
      font-family: PingFangSC-Semibold;
      font-size: 24rpx;
      letter-spacing: 1rpx;
      font-weight: bold
      padding 4rpx 16rpx 4rpx 25rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m35525490"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index-app.mpx.js?isComponent&outputPath=components%2Findex-app35525490%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./index-app.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Findex-app35525490%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m35525490"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index-app35525490/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'res-banner':getComponent(require("../../components/common/res-banner.mpx?isComponent&outputPath=components%2Fres-banner12bfcde6%2Findex")),'error-view':()=>import(/* webpackChunkName: "error-view" */"../../components/common/error-view.mpx?async=error-view&isComponent&outputPath=components%2Ferror-view6fe98fb7%2Findex").then(res => getComponent(res)),'red-packet-close':getComponent(require("../../components/wyc/red-packet-close.mpx?isComponent&outputPath=components%2Fred-packet-close737628c2%2Findex")),'mpx-text':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-text.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
